import { useMemo } from 'react';

import { DeviceType, Preview } from '@appcharge/shared-ui';

import { cn } from 'components/lib/utils';

export const StorePreview: React.FC<{
  previewProps: React.ComponentProps<typeof Preview>;
}> = ({ previewProps }) => {
  const isMobile = useMemo(
    () => previewProps.device === DeviceType.MOBILE,
    [previewProps]
  );

  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-lg relative',
        isMobile
          ? 'mobile-preview w-[375px] h-5/6'
          : 'desktop-preview w-4/5 h-4/5 max-w-[1100px]'
      )}
    >
      <Preview {...previewProps} />
    </div>
  );
};
